import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.trim.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { ACTION_BUTTON_TYPES, adjustServerTimestamp, DATE_CONSIDERATIONS, isTrue, WAITLIST_STATUS_TYPES } from "@dp/common";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import i18next from "i18next";
import moment from "moment-timezone";
import { isOrderAheadRestaurant } from "../../utils/common";
export var RestaurantDetailModel = (_class = /*#__PURE__*/function () {
  function RestaurantDetailModel() {
    _classCallCheck(this, RestaurantDetailModel);

    _initializerDefineProperty(this, "_selectedRestaurantInLocation", _descriptor, this);

    _initializerDefineProperty(this, "_recentRestaurants", _descriptor2, this);

    _initializerDefineProperty(this, "_favoriteRestaurants", _descriptor3, this);

    _initializerDefineProperty(this, "_userProfile", _descriptor4, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor5, this);

    _initializerDefineProperty(this, "_targeters", _descriptor6, this);

    _initializerDefineProperty(this, "_makeReservationButtonSticky", _descriptor7, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor8, this);

    _defineProperty(this, "isRestaurantClosed", function (restaurantTimeZone, closedDays, addDays) {
      var isRestaurantHoliday = false,
          userCurrentDayInTZ;
      var closedDaysLength = closedDays === null || closedDays === void 0 ? void 0 : closedDays.length;
      var formattedClosedDays = closedDays === null || closedDays === void 0 ? void 0 : closedDays.map(function (day) {
        return moment(day, "MM/DD/YYYY").format(DATE_CONSIDERATIONS.DATE_FORMAT);
      });

      if (restaurantTimeZone) {
        var _moment, _moment$tz;

        userCurrentDayInTZ = moment((_moment = moment()) === null || _moment === void 0 ? void 0 : (_moment$tz = _moment.tz(restaurantTimeZone)) === null || _moment$tz === void 0 ? void 0 : _moment$tz.format(DATE_CONSIDERATIONS.DATE_FORMAT)).add(addDays, "days");
      }

      for (var index = 0; index < closedDaysLength; index++) {
        var _userCurrentDayInTZ;

        var closedDay = moment(formattedClosedDays[index]);

        if (closedDay.valueOf() === ((_userCurrentDayInTZ = userCurrentDayInTZ) === null || _userCurrentDayInTZ === void 0 ? void 0 : _userCurrentDayInTZ.valueOf())) {
          isRestaurantHoliday = true;
          break;
        }
      }

      return isRestaurantHoliday;
    });

    makeObservable(this);
  }

  _createClass(RestaurantDetailModel, [{
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      this._sessionDetails = _sessionDetails;
    }
  }, {
    key: "setUserProfile",
    value: function setUserProfile(data) {
      this._userProfile = data;
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(data) {
      var _data$configs;

      this._appAttributes = data;
      this._makeReservationButtonSticky = (data === null || data === void 0 ? void 0 : (_data$configs = data.configs) === null || _data$configs === void 0 ? void 0 : _data$configs.makeReservationButtonSticky) === "true" ? true : false;
    }
  }, {
    key: "waitlistAndReservationAvailabilityDescription",
    value: function waitlistAndReservationAvailabilityDescription() {
      var _this$_selectedRestau, _this$_selectedRestau2, _this$_selectedRestau3, _this$_selectedRestau4, _i18next$t;

      switch (this.waitlistAvailabilityStatus) {
        case WAITLIST_STATUS_TYPES.AVAILABLE:
          return i18next.t("text.restdetails.waitlist.available", {
            defaultValue: "We’ll save your place in line to shorten the wait at the following location."
          });

        case WAITLIST_STATUS_TYPES.UNAVAILABLE:
          return "".concat(i18next.t("text.restdetails.waitlist.unavailable.prefix", {
            defaultValue: "Waitlist is only available only between"
          }), " ").concat((_this$_selectedRestau = this._selectedRestaurantInLocation) === null || _this$_selectedRestau === void 0 ? void 0 : (_this$_selectedRestau2 = _this$_selectedRestau.WaitListInformation) === null || _this$_selectedRestau2 === void 0 ? void 0 : _this$_selectedRestau2.startTime, " ").concat(i18next.t("text.restdetails.waitlist.unavailable.seperator", {
            defaultValue: "to"
          }), " ").concat((_this$_selectedRestau3 = this._selectedRestaurantInLocation) === null || _this$_selectedRestau3 === void 0 ? void 0 : (_this$_selectedRestau4 = _this$_selectedRestau3.WaitListInformation) === null || _this$_selectedRestau4 === void 0 ? void 0 : _this$_selectedRestau4.endTime);

        case WAITLIST_STATUS_TYPES.NOT_AVAILABLE_FOR_THIS_LOCATION:
          return "";

        case WAITLIST_STATUS_TYPES.RESERVATION_ENABLED:
          return isTrue(!!i18next.exists("text.restdetails.waitlist.reservation") && !!((_i18next$t = i18next.t("text.restdetails.waitlist.reservation")) !== null && _i18next$t !== void 0 && _i18next$t.length), i18next.t("text.restdetails.waitlist.reservation"), "");

        default:
          return "";
      }
    }
  }, {
    key: "fetchRestaurantHoursForRD",
    value: function fetchRestaurantHoursForRD(hours, dayOfWeek, dateToCompare) {
      var hasSpecialHours = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var dayObj = {};
      hours === null || hours === void 0 ? void 0 : hours.forEach(function (restHour) {
        var _restHour$hourCode, _restHour$startDate, _restHour$endDate;

        var hourCode = restHour === null || restHour === void 0 ? void 0 : (_restHour$hourCode = restHour.hourCode) === null || _restHour$hourCode === void 0 ? void 0 : _restHour$hourCode.hourCode;

        if (moment(dateToCompare).isBetween(restHour === null || restHour === void 0 ? void 0 : (_restHour$startDate = restHour.startDate) === null || _restHour$startDate === void 0 ? void 0 : _restHour$startDate.time, restHour === null || restHour === void 0 ? void 0 : (_restHour$endDate = restHour.endDate) === null || _restHour$endDate === void 0 ? void 0 : _restHour$endDate.time) && (restHour === null || restHour === void 0 ? void 0 : restHour.startDayOfWeek) <= dayOfWeek && dayOfWeek <= (restHour === null || restHour === void 0 ? void 0 : restHour.endDayOfWeek)) {
          var _restHour$hourCode2, _objectSpread2;

          dayObj = _objectSpread(_objectSpread({}, dayObj), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, hourCode, {
            type: restHour === null || restHour === void 0 ? void 0 : (_restHour$hourCode2 = restHour.hourCode) === null || _restHour$hourCode2 === void 0 ? void 0 : _restHour$hourCode2.hourTypeName,
            startTime: moment("01-01-2022 ".concat(restHour === null || restHour === void 0 ? void 0 : restHour.startTime), "DD-MM-YYYY hh:mm:ss").format(DATE_CONSIDERATIONS.TIME_FORMAT),
            endTime: moment("01-01-2022 ".concat(restHour === null || restHour === void 0 ? void 0 : restHour.endTime), "DD-MM-YYYY hh:mm:ss").format(DATE_CONSIDERATIONS.TIME_FORMAT),
            message: restHour === null || restHour === void 0 ? void 0 : restHour.message
          }), _defineProperty(_objectSpread2, "hasSpecialHours", hasSpecialHours), _objectSpread2));
        }
      });
      return dayObj;
    }
  }, {
    key: "getTimeOfDay",
    value: function getTimeOfDay(currentMoment, hourStr) {
      var fullTimeStr = currentMoment.format("MM/DD/YYYY ") + hourStr;
      return moment(fullTimeStr, "MM/DD/YYYY h:mm A");
    }
  }, {
    key: "externalReservationTempLink",
    value: function externalReservationTempLink() {
      var _this$selectedRestaur, _this$selectedRestaur2, _this$selectedRestaur3, _this$selectedRestaur4, _this$selectedRestaur5, _this$selectedRestaur6;

      return isTrue(!!((_this$selectedRestaur = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur !== void 0 && _this$selectedRestaur.tmpReservationsLnkTxt) && !!((_this$selectedRestaur2 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur2 !== void 0 && _this$selectedRestaur2.tmpReservationsLnkURL) && ((_this$selectedRestaur3 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur3 === void 0 ? void 0 : (_this$selectedRestaur4 = _this$selectedRestaur3.tmpReservationsLnkTxt) === null || _this$selectedRestaur4 === void 0 ? void 0 : _this$selectedRestaur4.length) > 0 && ((_this$selectedRestaur5 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur5 === void 0 ? void 0 : (_this$selectedRestaur6 = _this$selectedRestaur5.tmpReservationsLnkURL) === null || _this$selectedRestaur6 === void 0 ? void 0 : _this$selectedRestaur6.length) > 0, true, false);
    }
  }, {
    key: "siteReservationEnabled",
    value: function siteReservationEnabled() {
      var _this$appAttributes, _this$appAttributes$c, _this$appAttributes2, _this$appAttributes2$;

      return isTrue(!!((_this$appAttributes = this.appAttributes) !== null && _this$appAttributes !== void 0 && (_this$appAttributes$c = _this$appAttributes.configs) !== null && _this$appAttributes$c !== void 0 && _this$appAttributes$c.reservationEnabled) && ((_this$appAttributes2 = this.appAttributes) === null || _this$appAttributes2 === void 0 ? void 0 : (_this$appAttributes2$ = _this$appAttributes2.configs) === null || _this$appAttributes2$ === void 0 ? void 0 : _this$appAttributes2$.reservationEnabled) === "true", true, false);
    }
  }, {
    key: "setTargeters",
    value: function setTargeters(data) {
      this._targeters = data === null || data === void 0 ? void 0 : data.targeter;
    }
  }, {
    key: "setMakeReservationButtonSticky",
    value: function setMakeReservationButtonSticky(data) {
      this._makeReservationButtonSticky = data;
    }
  }, {
    key: "userProfile",
    get: function get() {
      return this._userProfile;
    }
  }, {
    key: "productionURL",
    get: function get() {
      var _this$appAttributes3;

      return (_this$appAttributes3 = this.appAttributes) === null || _this$appAttributes3 === void 0 ? void 0 : _this$appAttributes3.productionURL;
    }
  }, {
    key: "appAttributes",
    get: function get() {
      return this._appAttributes;
    }
  }, {
    key: "selectedRestaurantInLocation",
    get: function get() {
      return this._selectedRestaurantInLocation;
    },
    set: function set(restaurant) {
      var _this = this;

      runInAction(function () {
        _this._selectedRestaurantInLocation = restaurant;
      });
    }
  }, {
    key: "recentRestaurants",
    set: function set(data) {
      var _this2 = this;

      runInAction(function () {
        _this2._recentRestaurants = data;
      });
    },
    get: function get() {
      return this._recentRestaurants;
    }
  }, {
    key: "togoAndCurbsideAmenities",
    get: function get() {
      var _i18next$t2, _i18next$t3;

      var restaurantInfo = this._selectedRestaurantInLocation;
      var amenities = [];

      if (restaurantInfo !== null && restaurantInfo !== void 0 && restaurantInfo.onlineTogo && !!i18next.exists("text.onlineamenity.title") && !!((_i18next$t2 = i18next.t("text.onlineamenity.title")) !== null && _i18next$t2 !== void 0 && _i18next$t2.length)) {
        amenities === null || amenities === void 0 ? void 0 : amenities.push({
          indicatorCode: "",
          imageUrl: i18next.t("link.onlineamenity.img", {
            defaultValue: ""
          }),
          longDescription: i18next.t("text.onlineamenity.title"),
          description: isTrue(i18next.exists("text.onlineamenity.desc"), i18next.t("text.onlineamenity.desc"), "")
        });
      }

      if (restaurantInfo !== null && restaurantInfo !== void 0 && restaurantInfo.curbsideTogo && !!i18next.exists("text.carsideamenity.title") && !!((_i18next$t3 = i18next.t("text.carsideamenity.title")) !== null && _i18next$t3 !== void 0 && _i18next$t3.length)) {
        amenities === null || amenities === void 0 ? void 0 : amenities.push({
          indicatorCode: "",
          imageUrl: i18next.t("link.carsideamenity.img", {
            defaultValue: ""
          }),
          longDescription: i18next.t("text.carsideamenity.title"),
          description: isTrue(i18next.exists("text.carsideamenity.desc"), i18next.t("text.carsideamenity.desc"), "")
        });
      }

      return amenities;
    }
  }, {
    key: "favoriteRestaurants",
    set: function set(data) {
      var _this3 = this;

      runInAction(function () {
        _this3._favoriteRestaurants = data;
      });
    },
    get: function get() {
      return this._favoriteRestaurants;
    }
  }, {
    key: "waitlistAvailabilityStatus",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes2, _this$_selectedRestau5, _this$_selectedRestau6;

      if (this !== null && this !== void 0 && this.isReservationEnabled) return WAITLIST_STATUS_TYPES.RESERVATION_ENABLED;

      if (!!((_this$_appAttributes = this._appAttributes) !== null && _this$_appAttributes !== void 0 && _this$_appAttributes.isWebaheadEnabled) && ((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : _this$_appAttributes2.isWebaheadEnabled) === true && !!((_this$_selectedRestau5 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau5 !== void 0 && (_this$_selectedRestau6 = _this$_selectedRestau5.WaitListInformation) !== null && _this$_selectedRestau6 !== void 0 && _this$_selectedRestau6.hasWaitlistHourCode)) {
        var _this$selectedRestaur7;

        if ((_this$selectedRestaur7 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur7 !== void 0 && _this$selectedRestaur7.webahead) {
          if (!!this.isWaitlistAvaialble) {
            return WAITLIST_STATUS_TYPES.AVAILABLE;
          } else {
            return WAITLIST_STATUS_TYPES.UNAVAILABLE;
          }
        }
      }

      return WAITLIST_STATUS_TYPES.NOT_AVAILABLE_FOR_THIS_LOCATION;
    }
  }, {
    key: "isWaitlistAvaialble",
    get: function get() {
      var _this$restaurantHours, _this$restaurantHours2, _this$selectedRestaur8, _this$selectedRestaur9;

      var wlStartHH = (_this$restaurantHours = this.restaurantHours) === null || _this$restaurantHours === void 0 ? void 0 : _this$restaurantHours.waitlistStartTime;
      var wlCloseHH = (_this$restaurantHours2 = this.restaurantHours) === null || _this$restaurantHours2 === void 0 ? void 0 : _this$restaurantHours2.waitlistEndTime;
      var adjustedTS = adjustServerTimestamp((_this$selectedRestaur8 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur8 === void 0 ? void 0 : (_this$selectedRestaur9 = _this$selectedRestaur8.localTimestamp) === null || _this$selectedRestaur9 === void 0 ? void 0 : _this$selectedRestaur9.time);
      var restTZMoment = moment(adjustedTS);
      var restLocalTime = restTZMoment;
      var wlCloseTime = this.getTimeOfDay(restTZMoment, wlCloseHH);
      var wlStartTime = this.getTimeOfDay(restTZMoment, wlStartHH);
      return isTrue(!!wlStartTime && !!wlCloseTime && !!restLocalTime && restLocalTime.isBetween(wlStartTime, wlCloseTime), true, false);
    }
  }, {
    key: "showHolidayMsg",
    get: function get() {
      try {
        var _this$selectedRestaur10, _this$selectedRestaur11, _homObj$startDate, _homObj$endDate;

        var currentTimeStamp = Date.now();
        var homRestHourInfo = (_this$selectedRestaur10 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur10 === void 0 ? void 0 : (_this$selectedRestaur11 = _this$selectedRestaur10.restHourInfo) === null || _this$selectedRestaur11 === void 0 ? void 0 : _this$selectedRestaur11.filter(function (obj) {
          var _obj$hourCode;

          return (obj === null || obj === void 0 ? void 0 : (_obj$hourCode = obj.hourCode) === null || _obj$hourCode === void 0 ? void 0 : _obj$hourCode.hourCode) === "HOM_REST";
        });
        if (!(homRestHourInfo !== null && homRestHourInfo !== void 0 && homRestHourInfo.length)) return false;
        var homObj = homRestHourInfo[0];
        if (homObj !== null && homObj !== void 0 && homObj.showMessageOnly && currentTimeStamp >= (homObj === null || homObj === void 0 ? void 0 : (_homObj$startDate = homObj.startDate) === null || _homObj$startDate === void 0 ? void 0 : _homObj$startDate.time) && currentTimeStamp <= (homObj === null || homObj === void 0 ? void 0 : (_homObj$endDate = homObj.endDate) === null || _homObj$endDate === void 0 ? void 0 : _homObj$endDate.time)) return true;
        return false;
      } catch (_unused) {
        return false;
      }
    }
  }, {
    key: "holidayMessage",
    get: function get() {
      try {
        var _this$selectedRestaur12, _this$selectedRestaur13;

        var homRestHourInfo = (_this$selectedRestaur12 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur12 === void 0 ? void 0 : (_this$selectedRestaur13 = _this$selectedRestaur12.restHourInfo) === null || _this$selectedRestaur13 === void 0 ? void 0 : _this$selectedRestaur13.filter(function (obj) {
          var _obj$hourCode2;

          return (obj === null || obj === void 0 ? void 0 : (_obj$hourCode2 = obj.hourCode) === null || _obj$hourCode2 === void 0 ? void 0 : _obj$hourCode2.hourCode) === "HOM_REST";
        });
        if (!(homRestHourInfo !== null && homRestHourInfo !== void 0 && homRestHourInfo.length)) return "";
        var homObj = homRestHourInfo[0];
        return homObj === null || homObj === void 0 ? void 0 : homObj.message;
      } catch (_unused2) {
        return "";
      }
    }
  }, {
    key: "restaurantStatusMessage",
    get: function get() {
      var _this$restaurantHours3, _this$restaurantHours4, _this$restaurantHours5, _this$restaurantHours6;

      return i18next.t("text.locationsearch.status.opentill", {
        interpolation: {
          prefix: "${",
          suffix: "}"
        },
        starttime: (_this$restaurantHours3 = this.restaurantHours) === null || _this$restaurantHours3 === void 0 ? void 0 : _this$restaurantHours3.startTime,
        endtime: (_this$restaurantHours4 = this.restaurantHours) === null || _this$restaurantHours4 === void 0 ? void 0 : _this$restaurantHours4.endTime,
        defaultValue: "Open today ".concat((_this$restaurantHours5 = this.restaurantHours) === null || _this$restaurantHours5 === void 0 ? void 0 : _this$restaurantHours5.startTime, " to ").concat((_this$restaurantHours6 = this.restaurantHours) === null || _this$restaurantHours6 === void 0 ? void 0 : _this$restaurantHours6.endTime)
      });
    }
  }, {
    key: "restaurantHours",
    get: function get() {
      var restaurantDetails = this.selectedRestaurantInLocation;

      if (restaurantDetails) {
        var _hours, _this$selectedRestaur14, _this$selectedRestaur15, _this$selectedRestaur16, _this$selectedRestaur17;

        var currentDay = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.currentDay;
        var daysOfWeeks = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.daysOfWeeks;
        var hours = {};
        var currentDayIdx;

        if (daysOfWeeks) {
          currentDayIdx = daysOfWeeks === null || daysOfWeeks === void 0 ? void 0 : daysOfWeeks.reduce(function (res, dayOfWeek, idx) {
            if (dayOfWeek.toUpperCase() === (currentDay === null || currentDay === void 0 ? void 0 : currentDay.toUpperCase())) {
              return idx + 1; // array idx + 1
            } else {
              return res;
            }
          }, -1);
        }

        var restHourInfo = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.restHourInfo;
        var specialHours = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.restSplHrsInfo;
        var locationLevelSplHours = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.locationLevelSplHours;
        var siteLevelSplHours = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.siteLevelSplHours;
        var hasSpecialHours = false;

        if (restHourInfo) {
          var dayOfWeekT = 1;

          while (dayOfWeekT <= 7) {
            var _restaurantDetails$ad, _Object$keys;

            var todaysDate = moment.tz(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$ad = restaurantDetails.address) === null || _restaurantDetails$ad === void 0 ? void 0 : _restaurantDetails$ad.timeZone);
            var dateToCompare = null;

            if (dayOfWeekT >= (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.currentDaySeq)) {
              dateToCompare = todaysDate === null || todaysDate === void 0 ? void 0 : todaysDate.add(dayOfWeekT - (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.currentDaySeq), "days");
            } else {
              dateToCompare = todaysDate === null || todaysDate === void 0 ? void 0 : todaysDate.add(7 - (restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.currentDaySeq) + dayOfWeekT, "days");
            }

            var restHours = this.fetchRestaurantHoursForRD(restHourInfo, dayOfWeekT, dateToCompare);
            var restSpclHours = this.fetchRestaurantHoursForRD(specialHours, dayOfWeekT, dateToCompare, true);
            var siteSpclHours = this.fetchRestaurantHoursForRD(siteLevelSplHours, dayOfWeekT, dateToCompare, true);
            var locationSpclHours = this.fetchRestaurantHoursForRD(locationLevelSplHours, dayOfWeekT, dateToCompare, true);

            if (!hasSpecialHours && restSpclHours && (_Object$keys = Object.keys(restSpclHours)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
              hasSpecialHours = true;
            }

            hours = _objectSpread(_objectSpread({}, hours), {}, _defineProperty({}, dayOfWeekT, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, restHours), restSpclHours), siteSpclHours), locationSpclHours)));
            dayOfWeekT = dayOfWeekT + 1;
          }
        }

        var currentDay2 = String(currentDayIdx);
        var currentDayHours = (_hours = hours) === null || _hours === void 0 ? void 0 : _hours[currentDay2];
        var currentDayOPHours = (currentDayHours === null || currentDayHours === void 0 ? void 0 : currentDayHours.OP) || null;
        var waitlistStartTime = (_this$selectedRestaur14 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur14 === void 0 ? void 0 : (_this$selectedRestaur15 = _this$selectedRestaur14.WaitListInformation) === null || _this$selectedRestaur15 === void 0 ? void 0 : _this$selectedRestaur15.startTime;
        var waitlistEndTime = (_this$selectedRestaur16 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur16 === void 0 ? void 0 : (_this$selectedRestaur17 = _this$selectedRestaur16.WaitListInformation) === null || _this$selectedRestaur17 === void 0 ? void 0 : _this$selectedRestaur17.endTime;

        if (currentDayOPHours) {
          currentDayOPHours.waitlistEndTime = waitlistEndTime;
          currentDayOPHours.waitlistStartTime = waitlistStartTime;
        }

        return currentDayOPHours;
      }

      return null;
    }
  }, {
    key: "isWaitlistSectionButtonDisabled",
    get: function get() {
      return (this === null || this === void 0 ? void 0 : this.waitlistAvailabilityStatus) !== WAITLIST_STATUS_TYPES.AVAILABLE && (this === null || this === void 0 ? void 0 : this.waitlistAvailabilityStatus) !== WAITLIST_STATUS_TYPES.RESERVATION_ENABLED;
    }
  }, {
    key: "restOpensinFuture",
    get: function get() {
      var _restaurantInfo$openD, _restaurantInfo$openD2;

      var restaurantInfo = this.selectedRestaurantInLocation;
      return isTrue(!!(restaurantInfo !== null && restaurantInfo !== void 0 && (_restaurantInfo$openD = restaurantInfo.openDate) !== null && _restaurantInfo$openD !== void 0 && _restaurantInfo$openD.time) && moment(restaurantInfo === null || restaurantInfo === void 0 ? void 0 : (_restaurantInfo$openD2 = restaurantInfo.openDate) === null || _restaurantInfo$openD2 === void 0 ? void 0 : _restaurantInfo$openD2.time).isAfter(moment()), true, false);
    }
  }, {
    key: "isReservationEnabled",
    get: function get() {
      var _this$selectedRestaur18;

      return isTrue(!!((_this$selectedRestaur18 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur18 !== void 0 && _this$selectedRestaur18.reservationEnabled) && (!!this.siteReservationEnabled() || !!this.externalReservationTempLink()), true, false);
    }
  }, {
    key: "hideWaitlistSection",
    get: function get() {
      var _this$selectedRestaur19;

      return (this === null || this === void 0 ? void 0 : this.waitlistAvailabilityStatus) !== WAITLIST_STATUS_TYPES.AVAILABLE && (this === null || this === void 0 ? void 0 : this.waitlistAvailabilityStatus) !== WAITLIST_STATUS_TYPES.UNAVAILABLE && (this === null || this === void 0 ? void 0 : this.waitlistAvailabilityStatus) !== WAITLIST_STATUS_TYPES.RESERVATION_ENABLED || ((_this$selectedRestaur19 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur19 === void 0 ? void 0 : _this$selectedRestaur19.isRestaurantClosed) && !this.isReservationEnabled;
    }
  }, {
    key: "hideAmenitiesList",
    get: function get() {
      var _this$appAttributes4, _this$appAttributes4$, _this$appAttributes4$2;

      return ((_this$appAttributes4 = this.appAttributes) === null || _this$appAttributes4 === void 0 ? void 0 : (_this$appAttributes4$ = _this$appAttributes4.configs) === null || _this$appAttributes4$ === void 0 ? void 0 : (_this$appAttributes4$2 = _this$appAttributes4$.hideAmenitiesList) === null || _this$appAttributes4$2 === void 0 ? void 0 : _this$appAttributes4$2.split(",")) || [];
    }
  }, {
    key: "hideDisabledOrderOnlineCTA",
    get: function get() {
      var _this$appAttributes5, _this$appAttributes5$;

      return ((_this$appAttributes5 = this.appAttributes) === null || _this$appAttributes5 === void 0 ? void 0 : (_this$appAttributes5$ = _this$appAttributes5.configs) === null || _this$appAttributes5$ === void 0 ? void 0 : _this$appAttributes5$.hideDisabledOrderOnlineCTA) === "true";
    }
  }, {
    key: "isFavourite",
    get: function get() {
      var _this$userProfile,
          _this$userProfile2,
          _this4 = this; // transient -> true, logged out


      if ((_this$userProfile = this.userProfile) !== null && _this$userProfile !== void 0 && _this$userProfile["transient"]) return false; // transient -> false, logged in

      var favoriteLocation = (_this$userProfile2 = this.userProfile) === null || _this$userProfile2 === void 0 ? void 0 : _this$userProfile2.favoriteLocation;
      return favoriteLocation === null || favoriteLocation === void 0 ? void 0 : favoriteLocation.some(function (location) {
        var _this4$selectedRestau;

        if (location.restaurantNum === ((_this4$selectedRestau = _this4.selectedRestaurantInLocation) === null || _this4$selectedRestau === void 0 ? void 0 : _this4$selectedRestau.restaurantNum)) {
          return location === null || location === void 0 ? void 0 : location.isFavorite;
        }

        return false;
      });
    }
  }, {
    key: "targeters",
    get: function get() {
      return this._targeters;
    }
  }, {
    key: "isHappyHourEnabled",
    get: function get() {
      var _this$appAttributes6, _this$appAttributes6$;

      return ((_this$appAttributes6 = this.appAttributes) === null || _this$appAttributes6 === void 0 ? void 0 : (_this$appAttributes6$ = _this$appAttributes6.configs) === null || _this$appAttributes6$ === void 0 ? void 0 : _this$appAttributes6$.isHappyHourEnabled) === "true";
    }
  }, {
    key: "showHappyHour",
    get: function get() {
      var _this$selectedRestaur20;

      return (_this$selectedRestaur20 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur20 === void 0 ? void 0 : _this$selectedRestaur20.showHappyHour;
    }
  }, {
    key: "hideAmenityDescription",
    get: function get() {
      var _this$appAttributes7, _this$appAttributes7$;

      return ((_this$appAttributes7 = this.appAttributes) === null || _this$appAttributes7 === void 0 ? void 0 : (_this$appAttributes7$ = _this$appAttributes7.configs) === null || _this$appAttributes7$ === void 0 ? void 0 : _this$appAttributes7$.hideDescriptionForAmenities) === "true";
    }
  }, {
    key: "isLiveMusicEnabled",
    get: function get() {
      var _this$appAttributes8, _this$appAttributes8$;

      return ((_this$appAttributes8 = this.appAttributes) === null || _this$appAttributes8 === void 0 ? void 0 : (_this$appAttributes8$ = _this$appAttributes8.configs) === null || _this$appAttributes8$ === void 0 ? void 0 : _this$appAttributes8$.isLiveMusicEnabled) === "true";
    }
  }, {
    key: "showEventCalendar",
    get: function get() {
      var _this$selectedRestaur21;

      return (_this$selectedRestaur21 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur21 === void 0 ? void 0 : _this$selectedRestaur21.showEventCalendar;
    }
  }, {
    key: "displayBrandImageInRestDetails",
    get: function get() {
      var _this$appAttributes9, _this$appAttributes9$;

      return ((_this$appAttributes9 = this.appAttributes) === null || _this$appAttributes9 === void 0 ? void 0 : (_this$appAttributes9$ = _this$appAttributes9.configs) === null || _this$appAttributes9$ === void 0 ? void 0 : _this$appAttributes9$.displayBrandImageInRestDetails) === "true";
    }
  }, {
    key: "showPrivateDining",
    get: function get() {
      var _this$appAttributes10, _this$appAttributes11;

      return ((_this$appAttributes10 = this.appAttributes) === null || _this$appAttributes10 === void 0 ? void 0 : (_this$appAttributes11 = _this$appAttributes10.configs) === null || _this$appAttributes11 === void 0 ? void 0 : _this$appAttributes11.showPrivateDining) === "true";
    }
  }, {
    key: "privateDiningHome",
    get: function get() {
      var _this$appAttributes12, _this$appAttributes13;

      return (_this$appAttributes12 = this.appAttributes) === null || _this$appAttributes12 === void 0 ? void 0 : (_this$appAttributes13 = _this$appAttributes12.configs) === null || _this$appAttributes13 === void 0 ? void 0 : _this$appAttributes13.privateDiningHome;
    }
  }, {
    key: "happyHourLinkForRD",
    get: function get() {
      var _this$selectedRestaur22, _this$selectedRestaur23, _this$selectedRestaur24, _this$selectedRestaur25, _this$selectedRestaur26, _this$selectedRestaur27, _city$toLowerCase, _city$toLowerCase$spl, _city$toLowerCase$spl2;

      var state = (_this$selectedRestaur22 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur22 === void 0 ? void 0 : (_this$selectedRestaur23 = _this$selectedRestaur22.address) === null || _this$selectedRestaur23 === void 0 ? void 0 : (_this$selectedRestaur24 = _this$selectedRestaur23.state) === null || _this$selectedRestaur24 === void 0 ? void 0 : _this$selectedRestaur24.toLowerCase();
      var city = (_this$selectedRestaur25 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur25 === void 0 ? void 0 : (_this$selectedRestaur26 = _this$selectedRestaur25.address) === null || _this$selectedRestaur26 === void 0 ? void 0 : _this$selectedRestaur26.city;
      var restNum = (_this$selectedRestaur27 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur27 === void 0 ? void 0 : _this$selectedRestaur27.restaurantNum;
      var modifiedCity = city === null || city === void 0 ? void 0 : (_city$toLowerCase = city.toLowerCase()) === null || _city$toLowerCase === void 0 ? void 0 : (_city$toLowerCase$spl = _city$toLowerCase.split(" ")) === null || _city$toLowerCase$spl === void 0 ? void 0 : (_city$toLowerCase$spl2 = _city$toLowerCase$spl.join("-")) === null || _city$toLowerCase$spl2 === void 0 ? void 0 : _city$toLowerCase$spl2.concat("-restaurant");
      var defaultValue = "/happy-hour/".concat(state === null || state === void 0 ? void 0 : state.toLowerCase(), "/").concat(modifiedCity, "/").concat(restNum);

      if (state && city && restNum) {
        return i18next.t("label.restdetails.actionbuttons.happyhoururl", {
          defaultValue: defaultValue,
          interpolation: {
            prefix: "${",
            suffix: "}"
          },
          0: state,
          1: modifiedCity,
          2: restNum
        });
      } else {
        return "/happy-hour";
      }
    }
  }, {
    key: "liveMusicLink",
    get: function get() {
      var _this$selectedRestaur28, _this$selectedRestaur29, _this$selectedRestaur30, _this$selectedRestaur31, _this$selectedRestaur32, _this$selectedRestaur33, _city$toLowerCase2, _city$toLowerCase2$sp, _city$toLowerCase2$sp2;

      var _state = (_this$selectedRestaur28 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur28 === void 0 ? void 0 : (_this$selectedRestaur29 = _this$selectedRestaur28.address) === null || _this$selectedRestaur29 === void 0 ? void 0 : (_this$selectedRestaur30 = _this$selectedRestaur29.state) === null || _this$selectedRestaur30 === void 0 ? void 0 : _this$selectedRestaur30.toLowerCase();

      var _city = (_this$selectedRestaur31 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur31 === void 0 ? void 0 : (_this$selectedRestaur32 = _this$selectedRestaur31.address) === null || _this$selectedRestaur32 === void 0 ? void 0 : _this$selectedRestaur32.city;

      var _restNum = (_this$selectedRestaur33 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur33 === void 0 ? void 0 : _this$selectedRestaur33.restaurantNum;

      var _modifiedCity = _city === null || _city === void 0 ? void 0 : (_city$toLowerCase2 = _city.toLowerCase()) === null || _city$toLowerCase2 === void 0 ? void 0 : (_city$toLowerCase2$sp = _city$toLowerCase2.split(" ")) === null || _city$toLowerCase2$sp === void 0 ? void 0 : (_city$toLowerCase2$sp2 = _city$toLowerCase2$sp.join("-")) === null || _city$toLowerCase2$sp2 === void 0 ? void 0 : _city$toLowerCase2$sp2.concat("-restaurant");

      var _defaultValue = "/live-music/".concat(_state === null || _state === void 0 ? void 0 : _state.toLowerCase(), "/").concat(_modifiedCity, "/").concat(_restNum);

      if (_state && _city && _restNum) {
        return i18next.t("label.restdetails.actionbuttons.livemusicurl", {
          defaultValue: _defaultValue,
          interpolation: {
            prefix: "${",
            suffix: "}"
          },
          0: _state,
          1: _modifiedCity,
          2: _restNum
        });
      } else {
        return "/live-music";
      }
    }
  }, {
    key: "actionButtonsOrder",
    get: function get() {
      var _this$_appAttributes3, _this$_appAttributes4, _this$_appAttributes5;

      return ((_this$_appAttributes3 = this._appAttributes) === null || _this$_appAttributes3 === void 0 ? void 0 : (_this$_appAttributes4 = _this$_appAttributes3.configs) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.actionButtonsOrder) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.split(",").map(function (str) {
        return str === null || str === void 0 ? void 0 : str.trim();
      })) || [ACTION_BUTTON_TYPES.VIEW_MENU_BTN, ACTION_BUTTON_TYPES.ORDER_AHEAD_BTN, ACTION_BUTTON_TYPES.APPLY_NOW_BTN, ACTION_BUTTON_TYPES.HAPPY_HOUR_BTN, ACTION_BUTTON_TYPES.PRIVATE_DINING_BTN, ACTION_BUTTON_TYPES.LIVE_MUSIC_BTN];
    }
  }, {
    key: "makeReservationButtonSticky",
    get: function get() {
      return this._makeReservationButtonSticky;
    }
  }, {
    key: "showOrderAhead",
    get: function get() {
      var _this$_appAttributes6, _this$_appAttributes7, _this$selectedRestaur34, _this$selectedRestaur35, _this$appAttributes14, _this$appAttributes15;

      return isOrderAheadRestaurant((_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.configs) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.showOrderAheadListOfRestaurants, (_this$selectedRestaur34 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur34 === void 0 ? void 0 : _this$selectedRestaur34.restaurantInfo, (_this$selectedRestaur35 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur35 === void 0 ? void 0 : _this$selectedRestaur35.orderAheadEnabled, (_this$appAttributes14 = this.appAttributes) === null || _this$appAttributes14 === void 0 ? void 0 : (_this$appAttributes15 = _this$appAttributes14.configs) === null || _this$appAttributes15 === void 0 ? void 0 : _this$appAttributes15.disableOrderAheadBtnOnRDP);
    }
  }, {
    key: "isPermanentlyClosed",
    get: function get() {
      var _this$_selectedRestau7;

      var closedDate = (_this$_selectedRestau7 = this._selectedRestaurantInLocation) === null || _this$_selectedRestau7 === void 0 ? void 0 : _this$_selectedRestau7.closeDate;
      return !!(closedDate !== null && closedDate !== void 0 && closedDate.time) && moment(closedDate === null || closedDate === void 0 ? void 0 : closedDate.time).isSameOrBefore(moment());
    }
  }]);

  return RestaurantDetailModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_selectedRestaurantInLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_recentRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_favoriteRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_userProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_targeters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_makeReservationButtonSticky", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setSessionDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSessionDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserProfile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "productionURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "productionURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appAttributes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAppAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoAndCurbsideAmenities", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoAndCurbsideAmenities"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "favoriteRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "favoriteRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "waitlistAvailabilityStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "waitlistAvailabilityStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistAvaialble", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistAvaialble"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHolidayMsg", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHolidayMsg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "holidayMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "holidayMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantStatusMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantStatusMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantHours", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantHours"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistSectionButtonDisabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistSectionButtonDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restOpensinFuture", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restOpensinFuture"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReservationEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReservationEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideWaitlistSection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideWaitlistSection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideAmenitiesList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideAmenitiesList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDisabledOrderOnlineCTA", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideDisabledOrderOnlineCTA"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFavourite", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFavourite"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targeters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "targeters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTargeters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTargeters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isHappyHourEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isHappyHourEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHappyHour", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHappyHour"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideAmenityDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideAmenityDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLiveMusicEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLiveMusicEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showEventCalendar", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEventCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayBrandImageInRestDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayBrandImageInRestDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPrivateDining", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPrivateDining"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "privateDiningHome", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "privateDiningHome"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "happyHourLinkForRD", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "happyHourLinkForRD"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "liveMusicLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "liveMusicLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "actionButtonsOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "actionButtonsOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "makeReservationButtonSticky", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "makeReservationButtonSticky"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMakeReservationButtonSticky", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMakeReservationButtonSticky"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showOrderAhead", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showOrderAhead"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPermanentlyClosed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPermanentlyClosed"), _class.prototype)), _class);